// SubDevicesTab.jsx - 南向设备Tab组件
import React from 'react';
import { Table, Row, Col, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const COLORS = { primary: '#00d4ff', text: '#ffffff', muted: 'rgba(255,255,255,0.6)', solar: '#f4c542', storage: '#52e8b0', load: '#ff5a7f', grid: '#3a8dde' };
const cardStyle = { background: 'transparent', borderRadius: 8, border: '1px solid rgba(255,255,255,0.1)' };

const DEVICE_TYPE_TEXT = {
  'meter': 'device.meter',
  'bms': 'device.bms',
  'pcs': 'device.pcs',
  'pv': 'device.pv',
  'mppt': 'device.mppt',
  'air_conditioner': 'device.aircond',
  'liquid_cooling': 'device.liquidCool',
  'liquid_cool': 'device.liquidCool',
  'charger': 'device.charger',
  'fire': 'device.fire',
  'water': 'device.water',
  'door': 'device.door',
  'env': 'device.env',
  'dido': 'device.dido',
  'micro_grid': 'device.microGrid',
  'pcu': 'device.pcu',
  'tms': 'device.tms',
  'others': 'device.others',
};

const SubDevicesTab = ({ subDeviceStats, subDevices, loading, statusColor, statusText }) => {
  const { t } = useTranslation();
  const [current, setCurrent] = React.useState(1);

  return (
    <div style={{ padding: '16px' }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {subDeviceStats.map(item => (
          <Col xs={12} sm={8} md={6} key={item.type}>
            <div style={{ ...cardStyle, padding: '12px' }}>
              <div style={{ color: COLORS.muted, fontSize: 11, marginBottom: 4 }}>{t(DEVICE_TYPE_TEXT[(item.type || '').toLowerCase()] || item.type)}</div>
              <div style={{ color: COLORS.primary, fontSize: 18, fontWeight: 'bold' }}>{item.count}</div>
            </div>
          </Col>
        ))}
      </Row>
      <Table
        columns={[
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.index')}</span>, key: 'index', render: (_, __, i) => (current - 1) * 5 + i + 1, width: 50 },
          { title: 'sn', dataIndex: 'sn', key: 'sn', render: t => <span style={{ color: COLORS.primary }}>{t || '-'}</span>, width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.globalNo')}</span>, dataIndex: 'global_no', key: 'global_no', render: t => <span style={{ color: COLORS.primary }}>{t}</span>, width: 110 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.emsId')}</span>, dataIndex: 'ems_id', key: 'ems_id', render: v => v || '-', width: 70 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.emsName')}</span>, dataIndex: 'ems_name', key: 'ems_name', render: v => v || '-', width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.devClassType')}</span>, dataIndex: 'dev_class_type', key: 'dev_class_type', render: v => <Tag>{t(DEVICE_TYPE_TEXT[(v || '').toLowerCase()] || v)}</Tag>, width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.devType')}</span>, dataIndex: 'dev_type', key: 'dev_type', render: v => v || '-', width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.cabId')}</span>, dataIndex: 'cab_id', key: 'cab_id', render: v => v || '-', width: 70 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.cabName')}</span>, dataIndex: 'cab_name', key: 'cab_name', render: v => v || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.deviceNo')}</span>, dataIndex: 'no', key: 'no', render: v => v || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.deviceName')}</span>, dataIndex: 'name', key: 'name', render: t => t || '-', width: 120 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.online')}</span>, dataIndex: 'online', key: 'online', render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? t('status.online') : t('status.offline')}</Tag>, width: 70 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.status')}</span>, dataIndex: 'state', key: 'state', render: v => v || '-', width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.addr')}</span>, dataIndex: 'addr', key: 'addr', render: t => t || '-', width: 70 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.template')}</span>, dataIndex: 'template', key: 'template', render: t => t || '-', width: 160 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.vendor')}</span>, dataIndex: 'vendor', key: 'vendor', render: t => t || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.model')}</span>, dataIndex: 'model', key: 'model', render: t => t || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.channel')}</span>, dataIndex: 'channel', key: 'channel', render: v => v || '-', width: 130 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.protocol')}</span>, dataIndex: 'protocol', key: 'protocol', render: v => v || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.canId')}</span>, dataIndex: 'can_id', key: 'can_id', render: v => v || '-', width: 80 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.canMask')}</span>, dataIndex: 'can_id_mask', key: 'can_id_mask', render: v => v || '-', width: 80 },
        ]}
        dataSource={subDevices}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize: 5, showSizeChanger: false, showTotal: total => <span style={{ color: '#ffffff' }}>{t('cloud.total')} {total} {t('cloud.records')}</span>, onChange: (page) => setCurrent(page) }}
        style={{ background: 'transparent' }}
        scroll={{ x: 2400 }}
        tableLayout="fixed" />
    </div>
  );
};

export default SubDevicesTab;
